import * as models from 'smg/customer-api/models';
import { SearchSitePages, SearchText } from 'smg/customer-api/v2/sites';
import { ShowError } from 'smg/errors';
import QueryString from 'smg/querystring';

void main();

async function main() {
    const query = QueryString().get('q') || '';
    // Update search inputs
    document.querySelectorAll<HTMLInputElement>('input[type="search"]').forEach(input => input.value = query);

    if (!query.trim()) {
        showInitialState();
        return;
    }

    try {
        const results = await SearchSitePages({
            q: SearchText(query),
            data: 'title,url,highlightedSummary',
        });
        displayResults(results, query);
    } catch (error) {
        ShowError(error);
        showNoResults();
    }
}

function displayResults(results: models.SitePage[], query: string) {
    const $spinner = document.getElementById('search-spinner');
    const $resultsContainer = document.getElementById('search-results');
    const $container = document.getElementById('results-container');

    // Hide spinner, show results
    $spinner?.classList.add('d-none');
    $resultsContainer?.classList.remove('d-none');

    // Update counts and terms
    document.querySelectorAll('.search-count').forEach(el => el.textContent = results.length.toLocaleString());
    document.querySelectorAll('.search-term').forEach(el => el.textContent = query);

    // Clear container
    if ($container) {
        $container.innerHTML = '';
    }

    if (results.length === 0) {
        showNoResults();
        return;
    }

    const template = document.getElementById('search-result-template') as HTMLTemplateElement;

    if (!$container) {
        showNoResults();
        return;
    }

    results.forEach(result => {
        const $result = template.content.cloneNode(true) as DocumentFragment;

        const $link = $result.querySelector('.result-link') as HTMLAnchorElement;
        $link.href = result.url;
        $link.textContent = result.title;

        const $snippet = $result.querySelector('.result-snippet') as HTMLElement;
        $snippet.innerHTML = result.highlightedSummary;

        const $btn = $result.querySelector('.read-more-button') as HTMLAnchorElement;
        $btn.href = result.url;

        $container.appendChild($result);
    });
}

function showNoResults() {
    document.getElementById('search-spinner')?.classList.add('d-none');
    document.getElementById('search-results')?.classList.add('d-none');
    document.getElementById('initial-state')?.classList.add('d-none');
    document.getElementById('no-results')?.classList.remove('d-none');
}

function showInitialState() {
    document.getElementById('search-spinner')?.classList.add('d-none');
    document.getElementById('search-results')?.classList.add('d-none');
    document.getElementById('no-results')?.classList.add('d-none');
    document.getElementById('initial-state')?.classList.remove('d-none');
}

const clearSearchBtn = document.getElementById('clear-search-btn');
if (clearSearchBtn) {
    clearSearchBtn.addEventListener('click', () => {
        const input = document.querySelector('input[type="search"]') as HTMLInputElement;
        if (input) {
            input.value = '';
            input.focus();
        }
        showInitialState();
    });
}